import MenuLinkItem from "./menu-link-item.component";

export default MenuLinkItem;
